import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=9b9d0f9c&scoped=true"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"
import style0 from "./Knowledge.vue?vue&type=style&index=0&id=9b9d0f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d0f9c",
  null
  
)

export default component.exports